import SvgSprite from "../common/SvgSprite";
import { useLocation } from "react-router-dom";
import WebsiteLayout from "./WebsiteLayout";
import CustomerLayout from "./CustomerLayout";
import AdminLayout from "./AdminLayout";

export default function AppLayout({ children }) {
  const location = useLocation();
  const isAdminRoute = location.pathname.startsWith("/admin");
  const isCustomerRoute = location.pathname.startsWith("/customer");
  const Layout = isAdminRoute
    ? AdminLayout
    : isCustomerRoute
      ? CustomerLayout
      : WebsiteLayout;
  return (
    <div className="app-shell">
      <SvgSprite />
      <Layout>{children}</Layout>
    </div>
  );
}
